import { memo, useState } from 'react'
import CountDown from '@/components/CountDown/CountDown'
import PayCode from '@/components/PayCode/PayCode'
import payTip from '@/assets/images/payTip.png'
import { Button } from 'antd'
import './PaidBundle.less'

interface PaidBundleItem {
  label: string
}

interface PaidBundleProps {
  title?: string
  list: PaidBundleItem[]
  originPrice: number
  price: number
  diff: number
  items: Array<{ id: number; count: number }>
  listWidth?: number
  priceReduce?: string
  highlightLabel?: string
  containerClassName?: string
}

const PaidBundle = ({
  title,
  list,
  originPrice,
  price,
  diff,
  items,
  listWidth = 300,
  priceReduce,
  highlightLabel,
  containerClassName
}: PaidBundleProps) => {
  const [showPayCodeVisible, setShowPayCodeVisible] = useState(false)
  const onPay = () => {
    setShowPayCodeVisible(true)
  }
  return (
    <>
      <div className={`PaidBundle-container ${containerClassName ?? ''}`}>
        {title && <span className='title'>{title}</span>}
        {highlightLabel && <label className='label'>{highlightLabel}</label>}
        <ul style={{ width: `${listWidth}px` }}>
          {list.map((item, index) => {
            return <li key={index}>{item.label}</li>
          })}
        </ul>
        <img className='payTipImg' src={payTip} />
        <div className='right'>
          <CountDown showDays={true} startText='限定套餐' period={2} />
          <div className='price'>
            <div className='box'>
              <span className='originPrice'>单独买￥{originPrice}</span>
              <span className='mo'>¥</span>
              <span className='nowPrice'>{price}</span>
              <img src={priceReduce} />
            </div>
            <div className='shake'>
              <Button type='primary' className={`no-wave-button white-button`} onClick={() => onPay()}>
                立即抢购
              </Button>
            </div>
          </div>
        </div>
      </div>
      {showPayCodeVisible && (
        <PayCode
          visible={showPayCodeVisible}
          onCancel={() => {
            setShowPayCodeVisible(false)
          }}
          price={price}
          diff={diff}
          originalPrice={originPrice}
          items={items}
        />
      )}
    </>
  )
}

export default memo(PaidBundle)
